import type {Database} from './database.types';
export type AccountKind=Database['public']['Enums']['account_kind'];

/** HANDOFF §5 account types, in the order people pick them. Liabilities store positive amounts owed. */
export const accountKinds:readonly {kind:AccountKind;label:string;liability:boolean;cash:boolean}[]=[
 {kind:'checking',label:'Checking',liability:false,cash:true},
 {kind:'savings',label:'Savings',liability:false,cash:true},
 {kind:'cash',label:'Cash',liability:false,cash:true},
 {kind:'credit',label:'Credit card',liability:true,cash:false},
 {kind:'mortgage',label:'Mortgage',liability:true,cash:false},
 {kind:'personal_loan',label:'Personal loan',liability:true,cash:false},
 {kind:'auto_loan',label:'Auto loan',liability:true,cash:false},
 {kind:'student_loan',label:'Student loan',liability:true,cash:false},
 {kind:'investment',label:'Investment',liability:false,cash:false},
 {kind:'retirement',label:'Retirement',liability:false,cash:false},
 {kind:'crypto',label:'Cryptocurrency',liability:false,cash:false},
 {kind:'property',label:'Property',liability:false,cash:false},
 {kind:'other_asset',label:'Other asset',liability:false,cash:false},
 {kind:'other_liability',label:'Other liability',liability:true,cash:false},
];
export const kindValues=accountKinds.map(k=>k.kind) as [AccountKind,...AccountKind[]];
export const kindLabel=(k:AccountKind)=>accountKinds.find(x=>x.kind===k)?.label??k;
export const liabilityKinds=new Set<string>(accountKinds.filter(k=>k.liability).map(k=>k.kind));
export const cashKindSet=new Set<string>(accountKinds.filter(k=>k.cash).map(k=>k.kind));

/**
 * The signed ledger amount that moves an account from its current balance to a target
 * balance, both in cents. Liability balances are amounts owed, so a charge (negative
 * ledger amount) raises the balance.
 */
export function adjustmentAmount(kind:AccountKind,current:number,target:number){
 const change=target-current;
 return liabilityKinds.has(kind)?0-change:change;
}
